
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, BarChart, Activity, Video } from "lucide-react";
import PlayersTab from "./tabs/PlayersTab";
import BallAnalyticsTab from "./tabs/BallAnalyticsTab";
import TacticalInsightsTab from "./tabs/TacticalInsightsTab";
import PerformanceTab from "./tabs/PerformanceTab";

interface AnalysisTabsProps {
  analysisResult: any;
}

const AnalysisTabs: React.FC<AnalysisTabsProps> = ({ analysisResult }) => {
  if (!analysisResult) return null;
  
  return (
    <Tabs defaultValue="players">
      <TabsList className="grid grid-cols-4 mb-4">
        <TabsTrigger value="players">
          <Users className="h-4 w-4 mr-2" />
          Players
        </TabsTrigger>
        <TabsTrigger value="ball">
          <BarChart className="h-4 w-4 mr-2" />
          Ball Analytics
        </TabsTrigger>
        <TabsTrigger value="tactical">
          <Activity className="h-4 w-4 mr-2" />
          Tactical Insights
        </TabsTrigger>
        <TabsTrigger value="performance">
          <Video className="h-4 w-4 mr-2" />
          Performance
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="players" className="mt-0">
        <PlayersTab data={analysisResult.results.players} />
      </TabsContent>
      
      <TabsContent value="ball" className="mt-0">
        <BallAnalyticsTab data={analysisResult.results.ball} />
      </TabsContent>
      
      <TabsContent value="tactical" className="mt-0">
        <TacticalInsightsTab data={analysisResult.results.tacticalInsights} />
      </TabsContent>
      
      <TabsContent value="performance" className="mt-0">
        <PerformanceTab data={analysisResult.results.performanceComparison} />
      </TabsContent>
    </Tabs>
  );
};

export default AnalysisTabs;
